import { AuthResponse } from "../../typings/AuthResponse";
import { Endpoint } from "../../typings/endpoints";
import http from "../../utils/http";

interface LoginPayload {
  email: string;
  password: string;
}

interface RegisterPayload {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
}

const authApi = {
  login: async (payload: LoginPayload): Promise<AuthResponse> => {
    const response = await http.post<AuthResponse>(Endpoint.Login, payload);
    return response.data;
  },

  register: async (payload: RegisterPayload): Promise<AuthResponse> => {
    const response = await http.post<AuthResponse>(Endpoint.Register, payload);
    return response.data;
  },

  deactivateAccount: async (userId: number): Promise<{ detail: string }> => {
    const response = await http.post<{ detail: string }>(
      `${Endpoint.Users}${userId}/deactivate/`
    );
    return response.data;
  },
};

export default authApi;
